// BET == ODD, NO MODELO DEFINIDO POR SANDRO ESTA BETS, PORTANTO PRA NAO MUDAR O PADRAO MANTIVE A MESMA NOMECLATURA

import { FormControl, IconButton, InputLabel, MenuItem, Select, TextField, useTheme } from "@mui/material"
import { CrudStatus, IBet, IBetSettlement, IBetStatus } from "bets.oddprovider.lib.common.ts/models"
import { FlexGrowComponent, FormItemStyled } from "fwork.react.apptemplate"
import React, { useState } from "react"
import { SlArrowDown, SlArrowUp, } from "react-icons/sl"
import { DEFAULTGAP } from "../../globals"

export interface EventBetComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  bet: IBet,
  prior?: IBet,
  betStatusList: IBetStatus[],
  settlementList: IBetSettlement[],
  onChangeData?: (bet: IBet) => void,
}

export const EventBetComponent = React.memo((props: EventBetComponentProps) => {
  const { bet, prior, betStatusList, settlementList, onChangeData, ...rest } = props

  // console.log(`EventBetComponent.constructor: ${bet.id}; ${bet.name}`)
  const theme = useTheme()

  const [open, setOpen] = useState<boolean>()
  const [data, setData] = useState<IBet>(bet)
  const [priceInput, setPriceInput] = useState(data.price.toString());

  const handleClick = () => {
    setOpen(!open)
  }

  return <>
    {prior?.market_id != data.market_id &&
      <FormItemStyled aria-label="EventBetComponentProps-MARKETNAME" gap={DEFAULTGAP} style={{ color: 'white', background: theme.palette.primary.dark, padding: 10, borderRadius: 5, }} fullWidth>{data.market?.name}</FormItemStyled>}
    <FormItemStyled
      gap={DEFAULTGAP}
      style={{
        background: theme.palette.primary.light,
        color: 'white',
        padding: 10,
        borderRadius: 5,
        cursor: 'pointer',
      }}>
      <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
        <label>{data.name}</label>
        <FlexGrowComponent />
        <label>{data.price}</label>
        <IconButton style={{ marginLeft: 10 }} onClick={handleClick}> {open ? <SlArrowUp size={10} /> : <SlArrowDown size={10} />}</IconButton>
      </div>
      {open && <>
        <FormControl fullWidth style={{ marginTop: 10 }}>
          <TextField
            id="price-input"
            label="Preço"
            value={priceInput}
            slotProps={{
              input: {
                sx: {
                  color: "white", // cor do texto digitado
                },
              },
              inputLabel: {
                sx: {
                  color: "white", // cor do label
                  "&.Mui-focused": {
                    color: "white", // label quando focado
                  },
                },
              },
            }}
            onChange={(e) => {
              const value = e.target.value;
              setPriceInput(value);

              // tenta converter só se for válido
              const normalized = value.replace(",", "."); // aceita vírgula
              const num = parseFloat(normalized);

              let tmp = {
                ...data,
                price: isNaN(num) ? 0 : num, // decide como tratar vazio
                crudStatus: CrudStatus.update,
              } as IBet;

              if (onChangeData) onChangeData(tmp);
              setData(tmp);
            }}
          />
        </FormControl>
        <FormControl fullWidth style={{ marginTop: 10 }}>
          <InputLabel id="status-label" style={{ color: 'white', fontStyle: data.status_id ? 'normal' : 'italic' }}>{data.status_id ? 'Status' : 'Escolha um status'}</InputLabel>
          <Select
            style={{ color: 'white' }}
            labelId="status-label"
            id="status-input"
            value={data.status_id.toString()}
            label={betStatusList.filter(s => s.id == data.status_id)[0]?.name ?? ''}
            onChange={(e) => {
              let tmp = {
                ...data,
                status_id: Number(e.target.value),
                settlement_id: Number(e.target.value) == 13 ? data.settlement_id : null,
                crudStatus: CrudStatus.update,
              } as IBet

              if (onChangeData)
                onChangeData(tmp)

              setData(tmp)
            }}
          >
            {betStatusList.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth style={{ marginTop: 10 }}>
          <InputLabel style={{ color: 'white', fontStyle: data.settlement_id ? 'normal' : 'italic' }} id="settlement-label">{data.settlement_id ? 'Status Liquidado' : 'Escolha um status liquidado'}</InputLabel>
          <Select
            style={{ color: 'white' }}
            labelId="settlement-label"
            id="settlement-input"
            value={data.settlement_id?.toString() ?? ''}
            label={settlementList.filter(s => s.id == data.settlement_id)[0]?.name ?? ''}
            onChange={(e) => {
              let tmp = {
                ...data,
                settlement_id: Number(e.target.value),
                status_id: 13,
                crudStatus: CrudStatus.update,
              } as IBet

              if (onChangeData)
                onChangeData(tmp)

              setData(tmp)
            }}
          >
            {settlementList.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
      </>}
    </FormItemStyled>
  </>
  // }, (prev, next) => prev.bet.id == next.bet.id && prev.bet.status_id == next.bet.status_id && prev.bet.settlement_id == next.bet.settlement_id)
}, (prev, next) => JSON.stringify(prev) === JSON.stringify(next))